import { usePolicyOutletContext } from "~/pages/shared/policy/hooks/usePolicyOutletContext";
import { PolicyExceptionsTab } from "~/pages/shared/policy/tabs/PolicyExceptionsTab";

export function OrganizationPolicyExceptionsTab() {
  const { scope } = usePolicyOutletContext();
  return <PolicyExceptionsTab scopeMrn={scope.mrn} />;
}
